module.exports = __webpack_public_path__ + "static/media/ldsces.14f74c88.jpg";